import React, { useMemo } from 'react';
import { useReminder } from '../ReminderContext';

const ReminderModal = () => {
  const { modalVisible, modalMessage, modalBooking, closeModal } = useReminder();
  if (!modalVisible || !modalBooking) return null;

  const booking = modalBooking;
  const dt = new Date(booking.booking_datetime);
  const dateStr = dt.toLocaleString('th-TH', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' });

  const statusBadge = useMemo(() => {
    const map = {
      '-': { t: 'รอกำหนด', c: 'badge bg-secondary' },
      pending: { t: 'นัดหมาย(ไม่มัดจำ)', c: 'badge bg-secondary' },
      confirmed: { t: 'นัดหมาย(มัดจำ)', c: 'badge text-white', style: { backgroundColor: '#d4af37' } },
      completed: { t: 'เข้ารับบริการแล้ว', c: 'badge bg-success' },
      canceled: { t: 'ยกเลิกนัด', c: 'badge bg-danger' }
    };
    const i = map[booking.status] || { t: booking.status, c: 'badge bg-light text-dark' };
    return <span className={i.c} style={i.style}>{i.t}</span>;
  }, [booking.status]);

  const timeRemaining = useMemo(() => {
    const now = new Date();
    const diffMs = dt - now;
    if (diffMs <= 0) return 'ถึงเวลาแล้ว';
    const diffMins = Math.floor(diffMs / 60000);
    if (diffMins < 60) return `${diffMins} นาที`;
    const h = Math.floor(diffMins / 60); const m = diffMins % 60;
    return `${h} ชม. ${m} นาที`;
  }, [dt]);

  return (
    <div className="modal-overlay" style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2000, backdropFilter: 'blur(6px)', WebkitBackdropFilter: 'blur(6px)' }}>
      <div className="modal-content" style={{ background: '#fff', borderRadius: 14, padding: '1.3rem 1.6rem', width: 'min(560px,96%)', boxShadow: '0 12px 34px rgba(0,0,0,0.25)' }}>
        <div className="d-flex align-items-center mb-2"><i className="fas fa-bell text-warning me-2" style={{ fontSize: '1.3rem' }}></i><h5 className="mb-0">การแจ้งเตือนนัดหมาย</h5></div>
        <div className="alert alert-warning py-2 mb-3" style={{ fontSize: '0.9rem' }}>{modalMessage}</div>
        <div className="row g-3">
          <div className="col-md-6">
            <div className="small text-muted">ลูกค้า</div>
            <div className="fw-bold"><i className="fas fa-user me-1" /> {booking.customer_name}</div>
            {booking.customer_phone && <div className="text-muted"><i className="fas fa-phone me-1" /> {booking.customer_phone}</div>}
          </div>
          <div className="col-md-6">
            <div className="small text-muted">วันและเวลา</div>
            <div className="fw-bold"><i className="fas fa-clock me-1" /> {dateStr}</div>
            <div className="text-muted"><i className="fas fa-hourglass-half me-1" />เหลือ {timeRemaining}</div>
          </div>
          <div className="col-md-6">
            <div className="small text-muted">บริการ</div>
            <div><span className="badge bg-light text-dark"><i className="fas fa-spa me-1" /> {booking.service_name || '-'}</span></div>
          </div>
          <div className="col-md-6">
            <div className="small text-muted">พนักงาน</div>
            <div><span className="badge bg-secondary text-white"><i className="fas fa-user-tie me-1" /> {booking.employee_name || '-'}</span></div>
          </div>
          <div className="col-md-6">
            <div className="small text-muted">สถานะ</div>
            <div>{statusBadge}</div>
          </div>
          <div className="col-md-6">
            <div className="small text-muted">หมายเหตุ</div>
            <div style={{ minHeight: '1.5rem' }}>{booking.notes ? <span>{booking.notes}</span> : <span className="text-muted">-</span>}</div>
          </div>
        </div>
        <div className="d-flex justify-content-end gap-2 mt-4">
          <button className="btn btn-outline-secondary" onClick={closeModal}><i className="fas fa-times me-1" />ปิด</button>
        </div>
      </div>
    </div>
  );
};

export default ReminderModal;
